export enum ParticipantSupportRole {
  Mentor = 1,
  Assistant = 2,
  CloseRelative = 3,
}
